import { S21RossComponent } from "./S21RossComponent";

export function S21RossScreen() {
  return (
    <>
      <S21RossComponent />
    </>
  );
}
